import { Alert, AlertIcon, Box, Button, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react'
import DataTable from 'src/components/tables/DataTable';
import { colDefs } from './constants';
import { useNavigate } from 'react-router-dom';
import Loading from 'src/components/loading/Loading';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import DeleteModal from './components/DeleteModal';
import { getLanguages } from 'src/view-models/Languages';

const Languages = () => {
  const dispatch = useAppDispatch()
  const navigation = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const { languages } = useAppSelector((state) => state.language)
  const [isTranslating, setIsTranslating] = useState<boolean>(localStorage.getItem("is-translating") ? true : false)
  const goToAddLanguages = () => {
    navigation('/admin/languages/new')
  }

  useEffect(() => {
    const fetchLanguages = async () => {
      await getLanguages(dispatch)
      setIsLoading(false)
    }
    fetchLanguages()
  }, [])

  useEffect(() => {
    const syncWithLocalStorage = () => {
      const isTranslating = localStorage.getItem("is-translating") ? true : false
      setIsTranslating(isTranslating)
    }

    // Handle changes in the same tab
    const interval = setInterval(syncWithLocalStorage, 1000)

    // Handle changes in other tabs
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "is-translating") {
        syncWithLocalStorage()
      }
    }
    window.addEventListener("storage", handleStorageChange)

    // Cleanup on unmount
    return () => {
      clearInterval(interval)
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box px={4} py={2} rounded={4}  >
      <DeleteModal />
      {isTranslating && (
        <Alert status='info'>
          <AlertIcon />
          les questions sont en cours de traduction en langue {JSON.parse(localStorage.getItem("is-translating")!)?.name}
        </Alert>
      )}
      <Flex height={'100px'} flexDirection={{ base: 'column', md: 'row' }} alignItems={{ base: 'flex-start', md: 'center' }} justifyContent='space-between' gap={4} >
        <Box>
          <Text color='#4E5D78' fontWeight={700} fontSize={30} >Les langues</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant les lanngues</Text>
        </Box>
        <Button isDisabled={isTranslating} colorScheme='blue' onClick={goToAddLanguages} >Ajouter Une langue</Button>
      </Flex>
      <Box my={8} >
        <DataTable columns={colDefs} data={languages} />
      </Box>
    </Box>
  )
}

export default Languages